export default __webpack_public_path__ + "static/media/bridge-icon.51ef08f4.svg";